import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DumbTooltip, DumbTooltipProps } from '~/components/Tooltip/Dumb/DumbTooltip';
import styles from './Tooltip.module.scss';

export type TooltipProps = {
  closeDelay?: number;
} & DumbTooltipProps;

export const Tooltip = ({
  className,
  closeDelay = 0,
  children,
  onClick,
  ...props
}: TooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (active && closeDelay) {
      timeout = setTimeout(() => {
        setActive(false);
      }, closeDelay);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [active, closeDelay]);

  useEffect(() => {
    const onBodyClick = (e: MouseEvent) => {
      const contained = ref.current?.contains(e.target as Node);
      if (active && !contained) {
        setActive(false);
      }
    };
    document.body.addEventListener('click', onBodyClick, true);
    return () => document.body.removeEventListener('click', onBodyClick, true);
  }, [active]);

  const handleClick = useCallback(
    (e) => {
      setActive((prevState) => !prevState);
      onClick?.(e);
    },
    [onClick, setActive]
  );

  return (
    <DumbTooltip
      ref={ref}
      className={classNames(styles.root, className)}
      active={active}
      onClick={handleClick}
      {...props}>
      {children}
    </DumbTooltip>
  );
};
